module.exports = __webpack_public_path__ + "img/xiaoshigong_fwsrz.bf34d22b.png";